import PropTypes from 'prop-types';
import React from 'react';
import { fieldInputPropTypes } from 'redux-form';

import kebabCase from 'kebab-case';
import MuCheckbox from 'material-ui/Checkbox';
import { FormControlLabel } from 'material-ui/Form';

export const Checkbox = ({ id, label, input }) => {
  const { value, ...rest } = input;
  const fieldId = id || kebabCase(input.name);

  return (
    <FormControlLabel
      control={(
        <MuCheckbox
          id={fieldId}
          checked={value}
          value={value.toString()}
          {...rest}
        />
      )}
      label={label}
    />
  );
}

Checkbox.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.bool,
  input: PropTypes.shape(fieldInputPropTypes).isRequired
}
Checkbox.defaultProps = {
  id: undefined,
  value: false,
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/common/formComponents/Checkbox.js